import { render, staticRenderFns } from "./SubmitStatusQuerylogsForm.vue?vue&type=template&id=32617f1c&"
import script from "./SubmitStatusQuerylogsForm.vue?vue&type=script&lang=js&"
export * from "./SubmitStatusQuerylogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports